/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientCard/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import Avatar from 'DesignSystem/Avatar/index'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PatientCard({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/IntegrationsApplications/Content/SyncPatients/Content/SyncPatients/Content/PatientCard/ReplacePatient/ReplaceDialog/SearchResult/Content/PatientCard",
  presignedUrl
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let personPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'patient._id',
})
let replaceSelectedPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'replace',
path: 'selected_patient.id',
})
let aggregateData = fromAggregate.equals(personPatientIdValueData, replaceSelectedPatientIdValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  presignedUrl
  
})
let personValueData = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromFormat.initials,
})
let personValueData1 = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromHelpers.getName,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let personContactMethodAssociationsValueData = fromData.useDataFormat({ viewPath,
context: 'person',
path: 'contact_method_associations',
format: fromHelpers.getEmail,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let personContactMethodAssociationsValueData1 = fromData.useDataFormat({ viewPath,
context: 'person',
path: 'contact_method_associations',
format: fromHelpers.getPhone,
})
  return (<React.Fragment
>
<div
  data-testid="PatientCard.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-Z2tNy7O': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="person.patient._id"
 data="replace.selected_patient.id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
 paddingRight={0}
/>
<div
  data-testid="PatientCard.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 profile_url={presignedUrl}
 data="person"
 format="/Data/format.js initials"
 initials={personValueData}
/>
<div
  data-testid="PatientCard.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 backgroundColor={dtColorsNeutral900}
 data="person"
 format="helpers.js getName"
 text={personValueData1}
/>
<div
  data-testid="PatientCard.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-2-Z2tNy7O': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="person.contact_method_associations"
 format="helpers.js getEmail"
 text={personContactMethodAssociationsValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="person.contact_method_associations"
 format="helpers.js getPhone"
 text={personContactMethodAssociationsValueData1}
/>
</div>
</div>
</div>
</div>
{children}
</React.Fragment>)
}